import { roundToNearestStep, clamp, percentageToValue } from './utils.common.js';

var getOwnerDocument = function getOwnerDocument(sliderRef) {
  var _sliderRef$current;
  return ((_sliderRef$current = sliderRef.current) === null || _sliderRef$current === undefined ? undefined : _sliderRef$current.ownerDocument) || document;
};
var getNewValue = function getNewValue(sliderRef, pos, min, max, step, precision) {
  // istanbul ignore next -- ref sanity
  if (!sliderRef.current) return;
  var _sliderRef$current$ge = sliderRef.current.getBoundingClientRect(),
    width = _sliderRef$current$ge.width,
    left = _sliderRef$current$ge.left;
  var percent = (pos.x - left) / width;
  var value = percentageToValue(percent, min, max);
  var rounded = roundToNearestStep(value, min, step, precision);
  return clamp(rounded, min, max);
};

export { getNewValue, getOwnerDocument };
